import { Component, computed, inject, input } from '@angular/core';
import { ADD_PRODUCTS_ROUTE, ADD_PRODUCTS_SEARCH_ROUTE } from '@mwe/constants';
import { NavigationStateService, PopupService } from '@mwe/services';
import { IPopupModel, NavigatingBackTo } from '@mwe/models';
import { OrderProductsPopupComponent } from '../order-products-popup/order-products-popup.component';
import { Router } from '@angular/router';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'mwe-empty-products-state',
  templateUrl: './empty-products-state.component.html',
  standalone: true,
  imports: [EmptyStateComponent],
})
export class EmptyProductsStateComponent {
  emptyTitle = input.required<string>();
  emptyText = input.required<string>();
  navigatingBackTo = input<NavigatingBackTo>();
  hasFullSliderBar = computed<boolean>(() => this.navigationStateService?.navbarConfig?.hasAllProcesses);

  private router = inject(Router);
  private navigationStateService = inject(NavigationStateService);
  private popupService = inject(PopupService);

  onAddProductBtnClicked(): void {
    this.router.navigateByUrl(`/${ADD_PRODUCTS_ROUTE}/${ADD_PRODUCTS_SEARCH_ROUTE}`);
    this.navigationStateService.addNavigatingBackTo(this.navigatingBackTo());
  }

  onOrderProductBtnClicked(): void {
    const model: IPopupModel = {
      id: 'products-footer-order-products',
      component: OrderProductsPopupComponent,
      componentData: this.hasFullSliderBar(),
      dismissable: true,
      titleKey: 'newClient.title',
      modalSize: 'xl',
    };
    this.popupService.openV2(model);
  }
}
